import React from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {getChannelIconName} from '../../../../../helpers/channelViewHelpers';
import {ChannelModel} from '../../../../../models/api/channelModel';

/*
 * Type.
 */

interface ChannelPillProps {
  channel: ChannelModel;
}

/*
 * Styles.
 */

const StyledWrap = styled.div`
  border: 1px solid ${(p) => p.theme.greys.shade30};
  box-sizing: border-box;
  border-radius: 14px;
  padding: 3px 9px 4px 9px;
  background-color: ${(p) => p.theme.greys.white};
  display: inline-block;
  max-width: 100%;
`;

const StyledWrapInner = styled.div`
  display: flex;
  align-items: center;
`;

const StyledTitle = styled.div`
  margin-left: 5px;
  line-height: 17px;
  font-weight: ${fontWeights.normal};
  font-size: ${fontSizes.medium};
  color: ${(p) => p.theme.greys.shade80};
  white-space: nowrap;
  ${ellipsis()}
`;

/*
 * Component.
 */

export const ChannelPill = ({channel}: ChannelPillProps) => {
  const theme = useUserTheme();

  return (
    <div>
      <StyledWrap>
        <StyledWrapInner>
          <Icon name={getChannelIconName(channel.contactSource)} color={theme.greys.shade80} />
          <StyledTitle>{channel.displayName}</StyledTitle>
        </StyledWrapInner>
      </StyledWrap>
    </div>
  );
};
